<template>
  <div>
    <!-- <h5 class="info-text">{{$lang.titles.basic_settinsg}}</h5> -->

    <!-- CT ratio -->
    <div class="md-layout">
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-25 md-size-20 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('CT_RATIO') }]">
          <label>CT ratio</label>
          <md-input
            v-model="settings.CT_ratio"
            data-vv-name="CT_RATIO"
            type="text"
            name="CT_RATIO"
            v-validate="modelValidations.required"
            @change="changeCTRatio"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('CT_RATIO')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- CT Snom -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-25 md-size-20 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('CT_SNOM') }]">
          <label>CT Snom</label>
          <md-input
            v-model="settings.CT_snom"
            data-vv-name="CT_SNOM"
            type="text"
            name="CT_SNOM"
            v-validate="modelValidations.required"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('CT_SNOM')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- VT ratio -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-25 md-size-20 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('VT_RATIO') }]">
          <label>VT ratio</label>
          <md-input
            v-model="settings.VT_ratio"
            data-vv-name="VT_RATIO"
            type="text"
            name="VT_RATIO"
            v-validate="modelValidations.required"
            @change="changeVTRatio"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('VT_RATIO')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- VT Snom -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-25 md-size-20 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('VT_SNOM') }]">
          <label>VT Snom</label>
          <md-input
            v-model="settings.VT_snom"
            data-vv-name="VT_SNOM"
            type="text"
            name="VT_SNOM"
            v-validate="modelValidations.required"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('VT_SNOM')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <!-- I min -->
    <div class="md-layout">
      <label class="md-layout-item md-size-10 md-form-label">I min</label>

      <div
        class="md-layout-item md-xsmall-size-40 md-small-size-25 md-medium-size-25 md-size-20 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('I_MIN_SEC') }]">
          <label>Secondary</label>
          <md-input
            v-model="settings.I_min.secondary"
            type="text"
            name="I_MIN_SEC"
            v-validate="modelValidations.only_number"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('I_MIN_SEC')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <label class="md-layout-item md-size-5 md-form-label mx-auto">/</label>

      <div
        class="md-layout-item md-xsmall-size-40 md-small-size-25 md-medium-size-25 md-size-20 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('I_MIN_PRIM') }]">
          <label>Primary</label>
          <md-input
            v-model="settings.I_min.primary"
            type="text"
            name="I_MIN_PRIM"
            v-validate="modelValidations.only_number"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('I_MIN_PRIM')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <label class="md-layout-item md-size-5 md-form-label mx-auto">A</label>
    </div>

    <!-- I nom -->
    <div class="md-layout">
      <label class="md-layout-item md-size-10 md-form-label">I nom</label>

      <div
        class="md-layout-item md-xsmall-size-40 md-small-size-25 md-medium-size-25 md-size-20 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('I_NOM_SEC') }]">
          <label>Secondary</label>
          <md-input
            v-model="settings.I_nom.secondary"
            type="text"
            name="I_NOM_SEC"
            v-validate="modelValidations.only_number"
            @change="changeCTRatio('I_NOM_SECONDARY')"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('I_NOM_SEC')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <label class="md-layout-item md-size-5 md-form-label mx-auto">/</label>

      <div
        class="md-layout-item md-xsmall-size-40 md-small-size-25 md-medium-size-25 md-size-20 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('I_NOM_PRIM') }]">
          <label>Primary</label>
          <md-input
            v-model="settings.I_nom.primary"
            type="text"
            name="I_NOM_PRIM"
            v-validate="modelValidations.only_number"
            @change="changeCTRatio('I_NOM_PRIMARY')"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('I_NOM_PRIM')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <label class="md-layout-item md-size-5 md-form-label mx-auto">A</label>
    </div>

    <!-- I max -->
    <div class="md-layout">
      <label class="md-layout-item md-size-10 md-form-label">I max</label>

      <div
        class="md-layout-item md-xsmall-size-40 md-small-size-25 md-medium-size-25 md-size-20 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('I_MAX_SEC') }]">
          <label>Secondary</label>
          <md-input
            v-model="settings.I_max.secondary"
            type="text"
            name="I_MAX_SEC"
            v-validate="modelValidations.only_number"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('I_MAX_SEC')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <label class="md-layout-item md-size-5 md-form-label mx-auto">/</label>

      <div
        class="md-layout-item md-xsmall-size-40 md-small-size-25 md-medium-size-25 md-size-20 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('I_MAX_PRIM') }]">
          <label>Primary</label>
          <md-input
            v-model="settings.I_max.primary"
            type="text"
            name="I_MAX_PRIM"
            v-validate="modelValidations.only_number"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('I_MAX_PRIM')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <label class="md-layout-item md-size-5 md-form-label mx-auto">A</label>
    </div>

    <!-- U nom -->
    <div class="md-layout">
      <label class="md-layout-item md-size-10 md-form-label">U nom</label>

      <div
        class="md-layout-item md-xsmall-size-40 md-small-size-25 md-medium-size-25 md-size-20 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('U_NOM_SEC') }]">
          <label>Secondary</label>
          <md-input
            v-model="settings.U_nom.secondary"
            type="text"
            name="U_NOM_SEC"
            v-validate="modelValidations.only_number"
            @change="changeVTRatio('U_NOM_SECONDARY')"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('U_NOM_SEC')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <label class="md-layout-item md-size-5 md-form-label mx-auto">/</label>

      <div
        class="md-layout-item md-xsmall-size-40 md-small-size-25 md-medium-size-25 md-size-20 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('U_NOM_PRIM') }]">
          <label>Primary</label>
          <md-input
            v-model="settings.U_nom.primary"
            type="text"
            name="U_NOM_PRIM"
            v-validate="modelValidations.only_number"
            @change="changeVTRatio('U_NOM_PRIMARY')"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('U_NOM_PRIM')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <label class="md-layout-item md-size-5 md-form-label mx-auto">V</label>
    </div>

    <!-- Protocol Current -->
    <div class="md-layout">
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-40 md-size-35 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('PROTOCOL_CURRENT') }]">
          <label>Protocol current text</label>
          <md-input v-model="settings.protocol_current" type="text" name="PROTOCOL_CURRENT"></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('PROTOCOL_CURRENT')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- Protocol Voltage -->
      <div
        class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-40 md-size-35 mx-auto"
      >
        <md-field :class="[{ 'md-error': errors.has('PROTOCOL_VOLTAGE') }]">
          <label>Protocol voltage text</label>
          <md-input v-model="settings.protocol_voltage" type="text" name="PROTOCOL_VOLTAGE"></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('PROTOCOL_VOLTAGE')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <!-- Transformation ∆ ➙ Y-->
    <div class="md-layout">
      <label class="md-layout-item md-size-15 md-form-label">∆ ➙ Y</label>

      <div class="md-layout-item md-size-20">
        <md-switch v-model="settings.transformation"></md-switch>
      </div>
    </div>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      settings: {},
      defaultData: {
        CT_ratio: "1",
        CT_snom: "",
        VT_ratio: "1",
        VT_snom: "",
        I_min: {
          primary: "",
          secondary: ""
        },
        I_nom: {
          primary: "",
          secondary: ""
        },
        I_max: {
          primary: "",
          secondary: ""
        },
        U_nom: {
          primary: "",
          secondary: ""
        },
        protocol_current: "",
        protocol_voltage: "",
        transformation: false
      },

      modelValidations: {
        none: {},
        number_not_mandatory: {
          regex: /^[0-9]+$/
        },
        required: {
          required: true
        },
        only_number: {
          required: true,
          regex: /^[0-9]+$/
        }
      }
    };
  },
  created() {
    this.restartToDefault();
  },
  methods: {
    restartToDefault() {
      this.$validator.reset();
      this.errors.clear();
      this.settings = JSON.parse(JSON.stringify(this.defaultData));
    },
    changeCTRatio(key) {
      if (this.settings.CT_ratio > 0) {
        if (
          this.settings.I_min.primary > 0 &&
          this.settings.I_min.secondary > 0
        ) {
          this.settings.I_min.primary =
            this.settings.I_min.secondary * this.settings.CT_ratio;
        }
        if (
          this.settings.I_nom.primary > 0 &&
          this.settings.I_nom.secondary > 0
        ) {
          if (key == "I_NOM_PRIMARY") {
            this.settings.I_nom.secondary =
              this.settings.I_nom.primary / this.settings.CT_ratio;
          } else if (key == "I_NOM_SECONDARY") {
            this.settings.I_nom.primary =
              this.settings.I_nom.secondary * this.settings.CT_ratio;
          } else {
            this.settings.I_nom.primary =
              this.settings.I_nom.secondary * this.settings.CT_ratio;
          }

          this.settings.protocol_current =
            "3x" +
            this.settings.I_nom.primary +
            "/" +
            this.settings.I_nom.secondary +
            " A";
        }
        if (
          this.settings.I_max.primary > 0 &&
          this.settings.I_max.secondary > 0
        ) {
          this.settings.I_max.primary =
            this.settings.I_max.secondary * this.settings.CT_ratio;
        }
      }
    },

    changeVTRatio(key) {
      if (this.settings.VT_ratio > 0) {
        if (
          this.settings.U_nom.primary > 0 &&
          this.settings.U_nom.secondary > 0
        ) {
          if (key == "U_NOM_PRIMARY") {
            this.settings.U_nom.secondary =
              this.settings.U_nom.primary / this.settings.VT_ratio;
          } else if (key == "U_NOM_SECONDARY") {
            this.settings.U_nom.primary =
              this.settings.U_nom.secondary * this.settings.VT_ratio;
          } else {
            this.settings.U_nom.primary =
              this.settings.U_nom.secondary * this.settings.VT_ratio;
          }
          //this.settings.U_nom.primary = this.settings.U_nom.secondary * this.settings.VT_ratio;
          this.settings.protocol_voltage =
            "3x" +
            this.settings.U_nom.primary +
            "/" +
            this.settings.U_nom.secondary +
            " V";
        }
      }
    },

    validate() {
      return this.$validator.validateAll().then(res => {
        if (res) {
          this.$emit("on-validated", true, this.settings);
        }
        return res;
      });
    }
  }
};
</script>

<style></style>